import { createFileRoute } from '@tanstack/react-router'

import { ContractsPage } from '../../../../components/pages/contracts/contracts-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/contracts/')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <ContractsPage />
    </PermissionChecker>
  ),
})
